import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

import { Skeleton } from "@/components/skeleton";

export function RewardsSkeleton() {
  return (
    <div className={stack({ gap: "32" })}>
      <div className={stack({ gap: "8" })}>
        <Skeleton className={css({ h: "40", w: "176" })} />
        <Skeleton className={css({ h: "24", w: "320" })} />
      </div>
      <Skeleton className={css({ h: "224", w: "full", rounded: "primary" })} />
      <Skeleton className={css({ h: "40", w: "full" })} />
      <div
        className={css({
          display: "grid",
          gap: "12",
          gridTemplateColumns: {
            base: "minmax(0, 1fr)",
            sm: "repeat(2, minmax(0, 1fr))",
            desktop: "repeat(3, minmax(0, 1fr))",
          },
        })}
      >
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className={css({ h: "256", w: "full", rounded: "primary" })} />
        ))}
      </div>
    </div>
  );
}
